"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUserAgent = void 0;

var _react = require("react");

var useUserAgent = function useUserAgent() {
  var isIOSSafari = (0, _react.useMemo)(function () {
    var agent = navigator.userAgent.toLowerCase();
    return agent.includes('iphone') && agent.includes('safari');
  }, []);
  return {
    isIOSSafari: isIOSSafari
  };
};

exports.useUserAgent = useUserAgent;